"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generator_mission_test = void 0;
var imports_1 = require("@lib/imports");
var common_1 = require("@main/common");
var diveCrew_hero_data_1 = require("@voyage/crew/diveCrew_hero_data");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var voyageCarryableData_1 = require("@voyage/entities/voyageCarryableData");
var voyageMessageBuyRequest_sidecar_1 = require("@voyage/multi/voyageMessageBuyRequest-sidecar");
var voyageMessageCrewCreate_1 = require("@voyage/multi/voyageMessageCrewCreate");
var voyageMessageCrewCreate_sidecar_1 = require("@voyage/multi/voyageMessageCrewCreate-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageUiBuyStuff_data_1 = require("@voyage/ui/voyageUiBuyStuff_data");
var voyageTilemap_sidecar_1 = require("../tilemap/voyageTilemap-sidecar");
function generator_mission_test() {
    return __generator(this, function (_a) {
        if (!voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
            return [2 /*return*/, 0];
        }
        voyageGameStatus_sidecar_1.voyageGameStatus.get().addJumpCharge = 500;
        testItems();
        // testAliens()
        return [2 /*return*/, 0];
    });
}
exports.generator_mission_test = generator_mission_test;
function testItems() {
    var items = [
        voyageCarryableData_1.EVoyageCarryableType.BattleRifle,
        voyageCarryableData_1.EVoyageCarryableType.Coffee,
        voyageCarryableData_1.EVoyageCarryableType.Extinguisher,
        voyageCarryableData_1.EVoyageCarryableType.Medpack,
        voyageCarryableData_1.EVoyageCarryableType.Mop,
        voyageCarryableData_1.EVoyageCarryableType.Torpedo,
        voyageCarryableData_1.EVoyageCarryableType.Wrench,
        voyageCarryableData_1.EVoyageCarryableType.AlienCorpse,
    ];
    imports_1.l.forEach(items, function (c) {
        voyageMessageBuyRequest_sidecar_1.voyageMessageBuyRequest.sendMessageRequest({
            buyType: voyageUiBuyStuff_data_1.EBuyType.item,
            cost: 0,
            crewId: 0,
            itemType: c,
        });
    });
}
function testAliens() {
    for (var i = 0; i < 5; i++) {
        var tp = voyageTilemap_sidecar_1.voyageTilemap.getRandomFloor();
        voyageMessageCrewCreate_sidecar_1.voyageMessageCrewCreate.sendMessageAndImmediatelyExecute({
            crewId: common_1.createId(),
            team: 1,
            energy: 100,
            hitpoints: 100,
            method: voyageMessageCrewCreate_1.EVoyageCrewCreateMethod.Normal,
            type: diveCrew_1.EVoyageCrewType.Enemy,
            heroType: diveCrew_hero_data_1.EDiveHeroSubtype.None,
            enemyType: '',
            i: tp.i,
            j: tp.j,
        });
    }
}
